import React, { useEffect, useState } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Legend,
} from 'recharts';

const UserOverview = () => {
  const [stats, setStats] = useState({
    totalUsers: 0,
    activeUsers: 0,
    newSignups: 0,
  });
  const [signupTrends, setSignupTrends] = useState([]);
  const [countryStats, setCountryStats] = useState([]);

  useEffect(() => {
    const fetchUserOverview = async () => {
      try {
        const response = await fetch('http://localhost:5003/admin/user-overview');
        const data = await response.json();

        setStats({
          totalUsers: data.totalUsers,
          activeUsers: data.activeUsers,
          newSignups: data.newSignups,
        });

        setSignupTrends(data.signupTrends);
      } catch (error) {
        console.error('Error fetching user overview:', error);
      }
    };

    const fetchCountryStats = async () => {
      try {
        const response = await fetch('http://localhost:5003/admin/users-by-country');
        const data = await response.json();
        setCountryStats(data);
      } catch (error) {
        console.error('Error fetching users by country:', error);
      }
    };

    fetchUserOverview();
    fetchCountryStats();
  }, []);

  const COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#ff7f50', '#a4de6c', '#d0ed57', '#8dd1e1'];

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold">User Overview</h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white shadow-md rounded-xl p-4">
          <h3 className="text-lg font-medium">Total Users</h3>
          <p className="text-2xl font-bold">{stats.totalUsers}</p>
        </div>
        <div className="bg-white shadow-md rounded-xl p-4">
          <h3 className="text-lg font-medium">Active Users (7d)</h3>
          <p className="text-2xl font-bold">{stats.activeUsers}</p>
        </div>
        <div className="bg-white shadow-md rounded-xl p-4">
          <h3 className="text-lg font-medium">New Signups (7d)</h3>
          <p className="text-2xl font-bold">{stats.newSignups}</p>
        </div>
      </div>

      <div className="bg-white shadow-md rounded-xl p-4">
        <h3 className="text-lg font-medium mb-4">Signup Trends (Last 7 Days)</h3>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={signupTrends}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey="count" stroke="#3b82f6" strokeWidth={2} />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="bg-white shadow-md rounded-xl p-4 md:w-1/2">
        <h3 className="text-lg font-medium mb-4">Users by Country</h3>
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={countryStats}
              dataKey="count"
              nameKey="country"
              cx="50%"
              cy="50%"
              outerRadius={100}
              label
            >
              {countryStats.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default UserOverview;
